<div class="loader-overlay">
  <div class="icon">
    <svg-icon src="assets/logos/spinner.svg"></svg-icon>
  </div>
</div>
